// removed by extract-text-webpack-plugin
module.exports = {"membershipSummary":"membershipSummary__3h8Z-","isOpen":"isOpen__1-EP8","overlay":"overlay__3LQs2","trigger":"trigger__11Jg2","triggerLabel":"triggerLabel__1fPdK","triggerTypeAndPrice":"triggerTypeAndPrice__1gRAT","triggerCard":"triggerCard__NPBTQ","collapsible":"collapsible__zg_2U","content":"content__31Ve3","card":"card__3kEzs","bindingTime":"bindingTime__3yf2C","list":"list__sSFeT","item":"item__1rDd-","priceSummary":"priceSummary__1MJ_r","price":"price__3J3ol","divider":"divider__7gvco","person":"person__t3WQX","name":"name__1TAfN"};


//////////////////
// WEBPACK FOOTER
// ./components/signup-flow/step-payment/membership-summary.sass
// module id = O2RP
// module chunks = 1